import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { MainButton } from "components/Buttons";
import { MainInput } from "components/Inputs";
import { useNavigate } from "react-router";
import vendorServices from "services/vendorServices";
import toastPopup from "helpers/toastPopup";

export default function RegisterForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    name_en: "",
    email: "",
    password: "",
    "re-password": "",
    type: "vendor",
  });

  let formData = [
    { name: "name_en", type: "text", required: true },
    { name: "name_ar", type: "text", required: true },
    { name: "email", type: "email", required: true },
    { name: "password", type: "password", required: true },
    { name: "re-password", type: "password", required: true },
    { name: "phone", type: "tel", required: false },
    { name: "description_en", type: "textarea", required: false },
    { name: "description_ar", type: "textarea", required: false },
  ];
  let timer;
  async function registerHandler() {
    // const { value, error } = registerSchema.validate(user);
    console.log("first");
    const mappedData = {
      ...user,
      name: {
        en: user.name_en,
        ar: user.name_ar,
      },
      description: {
        en: user.description_en,
        ar: user.description_ar,
      },
    };
    delete mappedData.name_en;
    delete mappedData.name_ar;
    delete mappedData.description_en;
    delete mappedData.description_ar;
    delete mappedData["re-password"];
    setLoading(true);
    // if (error) {
    //   setErrorList(error.details);
    //   setErrorMessage(error.message);
    //   toast.error(error.name);
    // } else {
    try {
      const { data } = await vendorServices.register(mappedData);
      if (data.success && data.code === 201) {
        setLoading(false);
        toastPopup.success(t("Success"));
        navigate("/login");
      }
    } catch (e) {
      if (e.response.data.code === 409) {
        toast.error(e.response.data.error);
        timer = setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
      setLoading(false);
      setErrorMessage(e.response.data.error);
      // }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      {errorMessage ? <div className="err">{errorMessage}</div> : null}
      {formData.map((formInput, index) => {
        return (
          <MainInput
            key={index}
            name={formInput.name}
            type={formInput.type}
            required={formInput.required}
            state={user}
            setState={setUser}
          />
        );
      })}

      <MainButton
        text={t("createAccount")}
        type="button"
        loading={loading}
        onClick={registerHandler}
      />
    </>
  );
}
